<template>
    <!-- 生态页面主容器 -->
    <div class="main">
        <!-- 页面顶部横幅区域 -->
        <div class="banner">
            <!-- 左侧文本内容 -->
            <div class="banner-left">
                <!-- <div class="title">多维融合</div> -->
                <div class="title">{{$t('ecology.theme[0]')}}</div>
                <!-- <div class="title">重塑RWA生态价值网络</div> -->
                <div class="title">{{$t('ecology.theme[1]')}}</div>
                <div>
                    <div class="content" style="margin-top: 38px;">{{$t('ecology.advantage[0]')}}</div>
                    <div class="content">{{$t('ecology.advantage[1]')}}</div>
                </div>
            </div>
            <!-- 右侧Logo图片 -->
            <div class="banner-right">
                <img :src="require('../assets/ecology/logo.png')" alt="" />
            </div>
        </div>

        <!-- 引入Board组件 -->
        <Board></Board>
        <div class="container3">
        <!-- 生态内容主容器 -->
       <div class="ecology-container">
            
            

            <!-- 内容展示区域 -->
            <div class="content-area">
                <div class="content-section">
                    <!-- 区域头部信息 -->
                    <div class="section-header">
                        <div class="section-title">{{ tab[tabIndex].content.title }}</div>
                        <div class="section-description">{{ tab[tabIndex].content.describe }}</div>
                    </div>

                    <!-- 区域内容 -->
                    <div class="section-content">
                        <!-- 左侧特性列表 -->
                        <div class="content-left">
                            <div class="feature-item" v-for="(exItem, exIndex) in tab[tabIndex].content.ex"
                                :key="exIndex">
                                <div class="feature-icon">
                                    <img :src="exItem.icon" alt="" v-if="exItem.icon !== ''" />
                                </div>
                                <div class="feature-content">
                                    <div class="feature-title">{{ exItem.title }}</div>
                                    <div class="feature-description" v-for="(descItem, descIndex) in exItem.describe"
                                        :key="descIndex" :class="{ 'community-text': tabIndex === 5 }">
                                        {{ descItem }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 右侧图片展示 -->
                        <div class="content-right">
                            <img :src="tab[tabIndex].pic" alt="" />
                        </div>
                    </div>

                    <!-- 详细描述区域（条件渲染） -->
                    <div class="section-footer" v-if="tab[tabIndex].content.detailDescribe">
                        {{ tab[tabIndex].content.detailDescribe }}
                    </div>
                </div>
                 </div>
                 </div>
                  
     <div class="statistic">
      <div class="title">{{ $t('home.stakingdata.title') }}</div>
      <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin: 0 auto 40px;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰">
      </div>
      <div class="statistic-content">
        <div
          class="statistic-item"
          v-for="(item, index) in statistic"
          :key="index"
          :style="{ backgroundImage: `url(${require('../assets/mine/' + mineBgOrder[index] + '.png')})`, backgroundSize: 'cover', backgroundPosition: 'center' }"
        >
          <div class="item-text">{{ orderedStatTitles[index] }}</div>
          <div class="item-value">{{ valuePairs[index][0] }}</div>
          <div class="item-value24">{{ index >= 3 ? ('+' + valuePairs[index][1] + '(24H)') : valuePairs[index][1] }}</div>
        </div>
      </div>
    </div>
    <div class="globalpoint">
      <!-- globalpoint content -->
      <div class="search_box">
        <div style="display: flex; align-items: center; gap: 10px;">
            <div class="search">{{ $t('home.globalpoint.search_title') }}</div>
            <div class="search-icon" style="display: inline-block;"></div>
          </div>
        <div class="menu">
          <span class="menu-item">{{ $t('home.globalpoint.item1') }}</span>
          <span class="menu-item">{{ $t('home.globalpoint.item2') }}</span>
          <span class="menu-item">{{ $t('home.globalpoint.item3') }}</span>
          
        </div>
        <div class="table vote-scroll" style="margin: -25px auto 0 auto; height: 700px; width: 90%; overflow-y: scroll; padding-right: 12px; background-color: transparent; scrollbar-gutter: stable;">
        <table style="width: 100%; height: 100%; border-collapse: collapse;">
            <tbody>
              <tr v-for="(item, index) in voteTop" :key="item.srAddress">
                <td
                  :style="{
                    borderTop: index === 0 ? 'none' : '1px solid #ccc',
                    borderBottom: '1px solid #ccc',
                    borderLeft: 'none',
                    borderRight: 'none',
                    padding: '10px 10px 10px 80px',
                    color: 'white',
                    fontSize: '18px',
                    width: '20%',
                    height: '65px',
                    verticalAlign: 'middle'
                  }"
                >
                  {{ index + 1 }}
                </td>
                <td
                  :style="{
                    borderTop: index === 0 ? 'none' : '1px solid #ccc',
                    borderBottom: '1px solid #ccc',
                    borderLeft: 'none',
                    borderRight: 'none',
                    padding: '10px 10px 10px 120px',
                    color: 'white',
                    fontSize: '16px',
                    width: '20%',
                    height: '65px',
                    verticalAlign: 'middle'
                  }"
                >
                  {{ abbreviateAddress(item.srAddress) }}
                </td>
                <td
                  :style="{
                    borderTop: index === 0 ? 'none' : '1px solid #ccc',
                    borderBottom: '1px solid #ccc',
                    borderLeft: 'none',
                    borderRight: 'none',
                    padding: '10px 10px 10px 105px',
                    color: 'white',
                    fontSize: '16px',
                    width: '40%',
                    height: '65px',
                    verticalAlign: 'middle'
                  }"
                >
                  {{ item.voteNum }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
       
      </div>
      <div class="title">{{ $t('home.globalpoint.title') }}</div>
      <div style="position: absolute; right: 360px; top: 10px;font-size: 20px; cursor: pointer;" @click="openMiningRule">{{ $t('home.globalpoint.rule') }}→</div>    
      
      <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin-top: 0;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰" >
      </div>
      
      
      <img :src="require('../assets/global/picture.png')" alt="图片" style="display: block; position: relative; top: 80px; right: -1100px; width: 450px;">
      
      <div class="global_title">{{ $t('home.globalpoint.global_title') }}</div>
    
        <div class="google">
          <div class="google-play" style="display: inline-block;  text-align: left;">
            <img src="../assets/global/google-play.png" style="display: inline-block; vertical-align: middle; margin-right: 20px;" alt="Google Play" />
            <span style="vertical-align: middle; text-align: left;">GooglePlay</span>
          </div>
          <div class="android" style="display: inline-block; text-align: left;">
            <img src="../assets/global/android.png" style="display: inline-block; vertical-align: middle; margin-right: 20px;" alt="Android" />
            <span style="vertical-align: middle; text-align: left;">Android</span>
          </div>
        </div>
        
      
      <div class="download-container">
      <div class="download">{{ $t('home.globalpoint.download') }}</div>
      <div class="BITW">BIT Wallet</div>
      </div>
    </div>

            
           
        
       
</div>
        <!-- 挖矿规则弹窗 -->
        <RedBook :show="showMiningRule" @showReceive="closeMiningRule" :bookType="'mining'"></RedBook>
    </div>
</template>

<script>
// 导入Board组件
import Board from "@/components/Board.vue";
import RedBook from "../components/RedBook.vue";
import { voteRealPage, bitsStatisticHome, bitsStatisticBlock, bitUsdtPrice, parseBitUsdtPrice } from '@/api';

// 导出Ecology组件
export default {
    // 组件名称
    name: 'Ecology',
    
    // 注册使用的子组件
    components: { Board, RedBook },
    computed: {
      orderedStatTitles() {
        return [
          this.$t('home.statistic.accountCount2'),
          this.$t('home.statistic.liutong'),
          this.$t('home.statistic.transactionCount2'),
          this.$t('home.statistic.voteCount2'),
          this.$t('home.statistic.tokenCount2'),
          this.$t('home.statistic.stakeCount'),
        ];
      },
      valuePairs() {
        const d = { ...this.homeStatData, ...this.blockStatData } || {};
        const pairs = [
          ['account','account24'],
          ['transaction','transaction24'],
          ['totalNode','vote24'],
          ['vote','vote24'],
          ['blockReward','blockReward24'],
          ['voteReward','voteReward24'],
        ];
        const fmtNum = (val, decimals) => {
          const n = Number(val);
          if (isNaN(n)) return String(val || '');
          return typeof decimals === 'number' ? this.formatNumber(n, decimals) : this.formatNumber(n);
        };
        return pairs.map(([a,b], idx) => {
          if(idx === 0) return [fmtNum(100000000), '0']
          if (idx === 1) return [fmtNum(Number(d['blockReward'])+Number(d['voteReward'])+Number(30000000), 2), fmtNum(Number(d['blockReward24'])+Number(d['voteReward24'])+Number(30000000), 2)];
          if (idx === 2) return [fmtNum(d[a]), '0'];
          if (idx === 4) return [fmtNum(d[a], 2), fmtNum(d[b], 2)];
          if (idx === 5) return [fmtNum(Number(d[a]), 2), fmtNum(Number(d[b]), 2)];

          return [fmtNum(d[a]), fmtNum(d[b])];
        });
      }
    },
    
    // 数据定义
    data() {
        return {
            showMiningRule: false,
            // 当前选中的标签索引，默认为0（质押功能）
            tabIndex: 0,
            homeStat: { vote: 0, price: 0 },
            homeStatData: {},
            blockStatData: {},
            
            // 标签页数据配置，包含6个主要功能模块
            tab: [
                {
                    // 质押功能标签配置
                    content: {
                        title: this.$t('ecology.pledge.title'),
                        describe: this.$t('ecology.pledge.describe'),
                        ex: [
                            {
                                icon: require('../assets/ecology/pledge/exIcon/icon1.png'),
                                title: this.$t('ecology.pledge.ex[0].title'),
                                describe: this.$t('ecology.pledge.ex[0].describe'),
                            },
                            {
                                icon: require('../assets/ecology/pledge/exIcon/icon2.png'),
                                title: this.$t('ecology.pledge.ex[1].title'),
                                describe: this.$t('ecology.pledge.ex[1].describe'),
                            },
                            {
                                icon: require('../assets/ecology/pledge/exIcon/icon3.png'),
                                title: this.$t('ecology.pledge.ex[2].title'),
                                describe: this.$t('ecology.pledge.ex[2].describe'),
                            },
                        ],
                    },
                    pic: require('../assets/ecology/pledge/pledge.png'),
                },
                {
                    // 钱包功能标签配置
                    content: {
                        title: this.$t('ecology.wallet.title'),
                        describe: this.$t('ecology.wallet.describe'),
                        ex: [
                            {
                                icon: require('../assets/ecology/wallet/exIcon/icon1.png'),
                                title: this.$t('ecology.wallet.ex[0].title'),
                                describe: this.$t('ecology.wallet.ex[0].describe'),
                            },
                            {
                                icon: require('../assets/ecology/wallet/exIcon/icon2.png'),
                                title: this.$t('ecology.wallet.ex[1].title'),
                                describe: this.$t('ecology.wallet.ex[1].describe'),
                            },
                            {
                                icon: require('../assets/ecology/wallet/exIcon/icon3.png'),
                                title: this.$t('ecology.wallet.ex[2].title'),
                                describe: this.$t('ecology.wallet.ex[2].describe'),
                            },
                        ]
                    },
                    pic: require('../assets/ecology/wallet/wallet.png'),
                },
                {
                    // 扫描功能标签配置
                    content: {
                        title: this.$t('ecology.scan.title'),
                        describe: this.$t('ecology.scan.describe'),
                        ex: [
                            {
                                icon: require('../assets/ecology/scan/exIcon/icon1.png'),
                                title: this.$t('ecology.scan.ex[0].title'),
                                describe: this.$t('ecology.scan.ex[0].describe'),
                            },
                            {
                                icon: require('../assets/ecology/scan/exIcon/icon2.png'),
                                title: this.$t('ecology.scan.ex[1].title'),
                                describe: this.$t('ecology.scan.ex[1].describe'),
                            },
                        ]
                    },
                    pic: require('../assets/ecology/scan/scan.png'),
                },
                {
                    // 交换功能标签配置
                    content: {
                        title: this.$t('ecology.swap.title'),
                        describe: this.$t('ecology.swap.describe'),
                        ex: [
                            {
                                icon: require('../assets/ecology/swap/exIcon/icon1.png'),
                                title: this.$t('ecology.swap.ex[0].title'),
                                describe: this.$t('ecology.swap.ex[0].describe'),
                            },
                            {
                                icon: require('../assets/ecology/swap/exIcon/icon2.png'),
                                title: this.$t('ecology.swap.ex[1].title'),
                                describe: this.$t('ecology.swap.ex[1].describe'),
                            },
                            {
                                icon: require('../assets/ecology/swap/exIcon/icon3.png'),
                                title: this.$t('ecology.swap.ex[2].title'),
                                describe: this.$t('ecology.swap.ex[2].describe'),
                            },
                            {
                                icon: require('../assets/ecology/swap/exIcon/icon4.png'),
                                title: this.$t('ecology.swap.ex[3].title'),
                                describe: this.$t('ecology.swap.ex[3].describe'),
                            },
                            {
                                icon: require('../assets/ecology/swap/exIcon/icon5.png'),
                                title: this.$t('ecology.swap.ex[4].title'),
                                describe: this.$t('ecology.swap.ex[4].describe'),
                            },
                            {
                                icon: require('../assets/ecology/swap/exIcon/icon6.png'),
                                title: this.$t('ecology.swap.ex[5].title'),
                                describe: this.$t('ecology.swap.ex[5].describe'),
                            },
                        ]
                    },
                    pic: require('../assets/ecology/swap/swap.png'),
                },
                {
                    // NFT功能标签配置
                    content: {
                        title: this.$t('ecology.nft.title'),
                        describe: this.$t('ecology.nft.describe'),
                        ex: [
                            {
                                icon: require('../assets/ecology/nft/exIcon/icon1.png'),
                                title: this.$t('ecology.nft.ex[0].title'),
                                describe: this.$t('ecology.nft.ex[0].describe'),
                            },
                        ],
                        detailDescribe: this.$t('ecology.nft.detailDescribe')
                    },
                    pic: require('../assets/ecology/nft/nft.png'),
                },
                {
                    // 社区功能标签配置
                    content: {
                        title: this.$t('ecology.community.title'),
                        describe: this.$t('ecology.community.describe'),
                        ex: [
                            {
                                icon: '',
                                title: '',
                                describe: this.$t('ecology.community.ex[0].describe'),
                            },
                        ]
                    },
                    pic: require('../assets/ecology/community/community.png'),
                },
            ],
             statistic: [
        {
          icon: require('../assets/mine/faxing.png'),
          text: this.$t('home.statistic.liutong'),
          value: '',
          value24: '',
        },
        {
          icon: require('../assets/mine/liutong.png'),
          text: this.$t('home.statistic.stakeCount'),
          value: '',
          value24: '',
        },
        {
          icon: require('../assets/mine/zhiya.png'),
          text: this.$t('home.statistic.voteCount2'),
          value: '',
          value24: '',
        },
        {
          icon: require('../assets/mine/chanchu.png'),
          text: this.$t('home.statistic.tokenCount2'),
          value: '',
          value24: '',
        },
        {
          icon: require('../assets/mine/faxing.png'),
          text: this.$t('home.statistic.accountCount2'),
          value: '',
          value24: '',
        },
        {
          icon: require('../assets/mine/liutong.png'),
          text: this.$t('home.statistic.transactionCount2'),
          value: '',
          value24: '',
        }
      ],
      voteTop: [],
      mineBgOrder: [2,1,3,5,6,4],
      textOrder: [5,1,5,2,3,4],
        }
        
    },
    
    // 方法定义
    methods: {
        openMiningRule() {
            this.showMiningRule = true;
        },
        closeMiningRule(data) {
            this.showMiningRule = data;
        },
        abbreviateAddress(addr) {
            if (!addr || typeof addr !== 'string') return '';
            const len = addr.length;
            if (len <= 10) return addr;
            return `${addr.slice(0, 5)}···${addr.slice(-5)}`;
        },
        async loadVoteTop() {
            try {
                const res = await voteRealPage();
                const list = res && res.data && Array.isArray(res.data)
                    ? res.data
                    : (res && res.data && res.data.data && Array.isArray(res.data.data) ? res.data.data : []);
                this.voteTop = list;
            } catch (e) {
                console.error('loadVoteTop failed:', e);
                this.voteTop = [];
            }
        },

        /**
         * 加载首页统计数据
         */
        async loadHomeStat() {
          try {
            const res = await bitsStatisticHome();
            const data = res && res.data ? res.data : {};
            this.homeStatData = data;
            this.homeStat.vote = Number(data.vote || 0);

            const priceRes = await bitUsdtPrice();
            this.homeStat.price = Number(parseBitUsdtPrice(priceRes)) || 0;

            const blockRes = await bitsStatisticBlock();
            const blockData = blockRes && blockRes.data ? blockRes.data : {};
            this.blockStatData = blockData;

            if(this.blockStatData.blockReward == 0) {
              this.blockStatData.blockReward = 1119034.0000000000000;
            }

            if(this.blockStatData.voteReward == 0) {
              this.blockStatData.voteReward = 6882310.8244350908586;
            }
            
          } catch (e) {
            console.error('loadHomeStat failed:', e);
            // this.homeStatData = {};
            // this.blockStatData = {};
            // this.homeStat.vote = 0;
            // this.homeStat.price = 0;
          }
        },
        /**
         * 根据文本返回对应统计值
         */
        displayValue(item) {
          const t = item.text;
          const acc = this.$t('home.statistic.accountCount2');
          const trans = this.$t('home.statistic.transactionCount2');
          const vote = this.$t('home.statistic.voteCount2');
          const token = this.$t('home.statistic.tokenCount2');
          

          if (t === acc) return '100,000,000.00';
          if (t === trans) return '300,000,00';
          if (t === vote) return this.formatNumber(this.homeStat.vote);
          if (t === token) {
            const amount = (Number(this.homeStat.price) || 0) * 30000000;
            return this.formatNumber(amount, 2);
          }
          return '';
        },
        /**
         * 数字格式化
         */
        formatNumber(value, decimals) {
          const n = Number(value || 0);
          if (isNaN(n)) return String(value || 0);
          if (typeof decimals === 'number') {
            return n.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          } else {
            return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
        }
    },
    created() {
        this.loadVoteTop();
        this.loadHomeStat();
    }
}
</script>


<style lang="scss" scoped>
/* 主容器样式 - 使用SCSS嵌套语法 */
.main {
    width: 100%;
    // min-height: 100vh; // 注释掉的全屏高度设置
    // background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0f0f0f 100%); // 注释掉的背景渐变
    color: #ffffff; // 文字颜色设置为白色
    padding-top: 50px; // 顶部内边距
    // overflow-x: hidden; // 注释掉的横向溢出隐藏


    /* 横幅区域样式 */
    .banner {
        position: relative;
        min-width: 1000px;
        height: 576px;
        margin-bottom: 0px;
        padding-top: 50px;
        background-image: url("../assets/home/RWAbackground.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
        /* 固定宽度与居中 */
        width: 100%;
        
        margin: 0 auto;

        /* 新增：弹性居中布局 */
        display: flex;
        justify-content: center;
        align-items: center;
       
        box-sizing: border-box;

        /* 横幅左侧文本区域 */
        .banner-left {
            flex: 1 1 auto;
            max-width: 1000px;
            text-align: left;
            z-index: 2;
            position: relative;
            left: 200px;
            /* 标题样式 */
            .title {
                color: #ffffff;
                font-size: 70px;
                font-weight: 700;
                line-height: 1.2;
                margin-bottom: 10px;
                font-family: 'Arial', sans-serif;
                max-width: 1600px;
            }
           
            /* 内容文本样式 */
            .content {
                font-family: 'Arial', sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #aaa9a9a2;
                max-width: 100%;
            }
        }

        /* 横幅右侧图片区域 */
        .banner-right {
            top:40px;
            left:-50px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10;
            position: relative;
            
            img {
                width: 100%;
                height: auto;
                
            }
        }
    }

    /* 小屏适配 */
  
    .container3 {
      /* 生态页容器固定画布宽度 */
      width: 100%;
   
      min-width: 600px;
      margin: 0 auto;
      position: relative;
      background-image: url('../assets/background/background2.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }


    /* 生态内容容器 */
        .ecology-container {
            width: 100%;
            margin: 0 auto;
            padding-left: 40px;
            padding-right: 40px;  
            box-sizing: border-box;
          
  position: relative;
        /* 生态系统选项卡区域 - 已移除未使用的选项卡样式 */
       

        /* 内容区域样式 */
        .content-area {
            /* 内容板块 */
                .content-section {
                  
                   
                   
                    
                    max-width: 100%;
                    margin-bottom: -50px;
                    padding-top: 80px;

                /* 板块头部样式 */
                .section-header {
                 display: flex;
                    justify-content: center;
                    align-items: flex-start;
                  position: relative;
                    margin-bottom: 50px; // 与内容的间距
                    left: -410px;
                    
                    /* 板块标题 */
                    .section-title {
                        font-family: '微软雅黑';
                        font-size: 52px;
                        font-weight: 500; // 加粗
                        color: #ffffff;
                        
                        
                    }

                    /* 板块描述 */
                    .section-description {
                        font-family: '微软雅黑';
                        font-size: 20px;
                        color: #949191; // 灰色文字
                        line-height: 1.6; // 行高
                        position: relative;
                        left: -195px;
                        top: 60px;
                    }
                }

                /* 板块内容样式 */
                .section-content {
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    gap: 60px;

                    /* 左侧内容区域 */
                    .content-left {
                        flex: 1 1 auto;
                        max-width: 640px;

                        /* 特性项样式 */
                        .feature-item {
                            display: flex; // 弹性布局
                            margin-bottom: 10px; // 项之间的间距
                            align-items: flex-start; // 顶部对齐
                            position: relative;
                            left: 50px;
                            /* 特性图标 */
                            .feature-icon {
                                margin-right: 15px; // 与文字的间距
                                margin-top: 2px; // 轻微上移对齐

                                img {
                                    width: 24px;
                                    height: 24px;
                                }
                            }

                            /* 特性内容 */
                            .feature-content {
                                flex: 1; // 弹性占比

                                /* 特性标题 */
                                .feature-title {
                                    font-family: '微软雅黑';
                                    font-size: 24px;
                                    font-weight: 500; // 半粗体
                                    color: #ffffff;
                                    margin-bottom: 8px; // 与描述的间距
                                }

                                /* 特性描述 */
                                .feature-description {
                                    font-family: '微软雅黑';
                                    font-size: 20px;
                                    color: #818181; // 浅灰色文字
                                    line-height: 1.4; // 行高
                                    margin-bottom: 5px; // 底部间距
                                    width: 560px;

                                    /* 社区文本特殊样式 */
                                    &.community-text {
                                        color: #ac342e; // 红色文字
                                        font-weight: 600; // 半粗体
                                    }
                                }
                            }
                        }
                    }

                    /* 右侧图片区域 */
                    .content-right {
                      position: relative;
                      top:  -150px;
                        flex: 0 0 600px;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                          scale: 0.8;
                            width: 100%;
                            height: auto;
                            display: block;
                            transform: -60px;
                        }
                    }
                }

                /* 板块底部说明文字 */
                .section-footer {
                    margin-top: 30px; // 与内容的间距
                    font-size: 14px;
                    color: #aaaaaa; // 浅灰色文字
                    line-height: 1.6; // 行高
                }
            }


        }
    }
    .statistic {
      margin-top: 0px;
      font-size: 14px;
 
  position: relative;
      /* 固定画布与居中，移除负居中技巧 */
     width: 100%;
      min-width: 600px;
      margin: 0 auto;
      

      /* 固定高度（与 Home.vue 接近） */
      
      margin-bottom: 150px;
    // justify-content: space-between;

    .title {
      font-size: 44px;
      color: #fff;
      font-size: 700;
      font-family: emoji;
      font-weight: 600;
      text-align: center;
    }

    .statistic-content {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      max-width: 1200px;
      margin: 130px auto 0;
      gap: 16px;
     
      .statistic-item {
        background-color: transparent;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        
        height: 350px;
        flex: 0 0 calc((100% - 32px) / 3);
        margin: 0;
        padding-bottom: 40px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;

        .item-icon {
          margin-top: -60px;

          img {
            width: 120px;
            height: 140px;
          }
        }

        .item-text {
          font-family: "微软雅黑";
          font-size: 20px;
          font-weight: 540;
          top: 170px;
          position: relative;
          color: #ffff;
        }
        .item-value{
           font-family: "微软雅黑";
          font-size: 40px;
          font-weight: 540;
          top: 80px;
          position: relative;
          color: #ffff;
        }
        .item-value24 {
          color: #10f308;
          font-size: 18px;
          margin-top: -5px;

        }

        
      }
    }


    .tab+.tab {
      margin-left: 10px;
    }
  
  /* 投票排行滚动条样式，与 Home.vue 保持一致 */
  
    }
    .globalpoint {
      /* 固定宽度与居中 */
       height: 1181px;
  
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 1920px;
     
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    
    .title {
      font-family: "微软雅黑";
      color: #ece6e6;
      font-size: 50px;
      font-weight: 700;
      line-height: 1.2;
      margin-bottom: 0px;
      font-family: 'Arial', sans-serif;
      
      text-align: center;
      width: 100%;
    }

    .search_box {
      background-color: rgba(29, 28, 28, 0.76);
      width: 680px;
      height: 885px;
      position: absolute; 
      left: 360px; 
      top: 150px; /* 调整顶部位置，从500px改为100px，使其在可视区域内 */
      z-index: 10; /* 添加z-index确保显示在其他元素上方 */
      .search {
       font-family: "微软雅黑";
       color: #6d6c6c;
       font-size: 20px;
       padding-left: 20px;
       width: 350px;
       padding-top: 10px;
       margin-top: -40px; /* 向上移动30px */
      }
      .table {
  background-color: transparent !important;
}

/* 投票排行榜滚动条样式（与 Home.vue 保持一致） */
.vote-scroll {
  background-color: transparent !important;
  scrollbar-gutter: stable; // 为滚动条在右侧预留空间
  color-scheme: dark;        // 提示浏览器使用深色滚动条主题
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(56, 55, 55, 0.35) transparent;
}

/* Chrome / Edge / Safari — 使用 :deep 穿透 scoped 作用域，并完全透明化轨道 */
:deep(.vote-scroll)::-webkit-scrollbar {
  width: 8px;
  background: transparent !important;
}
:deep(.vote-scroll)::-webkit-scrollbar-track {
  background: transparent !important;
}
:deep(.vote-scroll)::-webkit-scrollbar-track-piece {
  background: transparent !important;
}
:deep(.vote-scroll)::-webkit-scrollbar-corner {
  background: transparent !important;
}
:deep(.vote-scroll)::-webkit-scrollbar-thumb {
  background: rgba(56, 55, 55, 0.35);
  border-radius: 4px;
}
    
    
        .search-icon {
        
          width: 400px; /* 设置宽度 */
          height: 100px; /* 设置高度 */
          
          scale: 1;
          margin-left: 120px; /* 减小右侧距离到10px */
          margin-top: 12px;
          font-size: 20px;
          color: #c2c2c280;
          text-align: center;
          padding-left: 50px;
          padding-top: 15px;
        }
        .menu {
          background-image: url('../assets/global/menu.png');
          background-repeat: no-repeat;
          background-position:  center;
          width: 700px; /* 减小宽度以压缩菜单项 */
          height: 100px; /* 设置高度 */
          font-family: "微软雅黑";
          color: #000000;
          font-size: 18px;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: -50px; /* 向上移动30px */
          font-weight: 600;
          margin-left: -10px; /* 向左移动，减小正值或设置为负值 */
        }
        
        .menu-item {
          margin: 0 80px;
          width: auto; /* 自动宽度 */
          white-space: nowrap; /* 确保文字不换行 */
        }
      }
    .global_title {
      font-family: "微软雅黑";
      color: #ece6e6;
      font-size: 40px;
      font-weight: 600;
      line-height: 1.2;
      margin-bottom: 0px;
      font-family: 'Arial', sans-serif;
      text-align: right;
      margin-top: 130px;
      right: 360px;
      position: relative;
      
    
    }
    
    .google {
      font-family: "微软雅黑";
      color: #ece6e6;
      font-size: 30px;
      font-weight: 200;
      line-height: 1.2;
      margin-bottom: 0px;
      font-family: 'Arial', sans-serif;
      text-align: right;
      margin-top: 30px;
      margin-right: 320px;
      .google-play {
        display: inline-block;
        background-image: url('../assets/global/system.png');
        background-size: cover;
        width: 250px;
        
        padding: 20px;
        margin-right: 10px;
      }
      .android {
        display: inline-block;
        background-image: url('../assets/global/system.png');
        background-size: cover;
        width: 200px;
        padding: 20px;
        margin-right: 30px;
        
      }
      
    
    
    }
    .download-container {
      
      display: flex;
      flex-direction: column;
      
      left: 1110px;
      position: relative;
      background-image: url('../assets/global/saomaxiazai.png');
      
      background-repeat: no-repeat;
      margin-top: 50px;
      height: 300px;
      width: 800px;
       /* 宽度拉长20%，高度保持100% */
      
    }
    
      .download {
        font-family: "微软雅黑";
        color: #ece6e6;
        font-size: 32px;
        font-weight: 550;
        line-height: 1.2;
        margin-bottom: 2px;
        font-family: 'Arial', sans-serif;
        text-align: left;
        
        margin-top:30px;
        margin-left: 170px; /* 添加左边距使文本向右移动 */
      }
      .BITW{
        font-family: "微软雅黑";
        color: #ece6e6;
        font-size: 48px;
        font-weight: 500;
        line-height: 1.2;
        margin-bottom: 2px;
        font-family: 'Arial', sans-serif;
        text-align: left;
        
        margin-top: 10px;
        margin-left: 200px; /* 添加左边距使文本向右移动 */
      }
      /* 已在HTML中使用内联样式设置search_box位置 */
  }
}
</style>
